export const commercialOverridesLabels = {
  'overrides.on_tire_locator': 'Tire/Retread Locator',
  'overrides.on_mechanical_locator': 'Mechanical Locator',
  'overrides.mcsn_member': 'MCSN Member',
  'overrides.service_tier_ranking': 'Service Rank',
  'overrides_value.service_tier_ranking_value': 'Rank',
  'overrides_value.service_tier_ranking_reason': 'Reason',
};

export interface CommercialOverrides {
  overrides: {
    mcsn_member: boolean,
    on_mechanical_locator: boolean,
    on_tire_locator: boolean,
    service_tier_ranking: boolean,
  },
  overrides_value: {
    mcsn_member: boolean,
    on_mechanical_locator: boolean,
    on_tire_locator: boolean,
    service_tier_ranking: string,
    service_tier_ranking_reason: string,
  },
  overrides_original: {
    mcsn_member: boolean,
    on_mechanical_locator: boolean,
    on_tire_locator: boolean,
    service_tier_ranking: string,
    service_tier_ranking_reason: string,
  },

}
